import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useClosable from '../../hooks/useClosable';
import McpAuthorizeApiService from '../../services/mcpAuthorizeApiService';
import { ClosableOrder } from '../../store/ClosableStore';
import commonStyles from '../Common.module.css';
import ValidationMessage from '../inputs/ValidationMessage';
import Modal from '../Modal';
import Spinner from '../spinners/Spinner';

function McpAuthorize() {
    const mcpAuthorizeApiService = useMemo(() => new McpAuthorizeApiService(), []);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const cancel = () => navigate("/");
    useClosable(ClosableOrder.High, cancel);

    const authorize = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const redirectUrl = await mcpAuthorizeApiService.authorize({
                redirectUri: searchParams.get("redirect_uri") ?? "",
                state: searchParams.get("state") ?? "",
                codeChallenge: searchParams.get("code_challenge") ?? "",
                codeChallengeMethod: searchParams.get("code_challenge_method") ?? "",
                nonce: searchParams.get("nonce") ?? "",
                scope: searchParams.get("scope") ?? "",
                clientId: searchParams.get("client_id") ?? "",
            });

            window.location.href = redirectUrl;
        } catch (error: any) {
            setError(error?.message ?? "Something went wrong. Try again later.");
            setIsLoading(false);
        }
    };

    return (
        <Modal header="Authorize Recity MCP" onClose={cancel}>
            Grant this MCP client access to your Recity account?
            {error && <ValidationMessage message={error} />}
            <div className={[commonStyles.modalControls, commonStyles.controlGroup].join(" ")}>
                {isLoading ? (
                    <Spinner />
                ) : (
                    <button className={commonStyles.primaryButton} onClick={authorize}>Authorize Recity MCP</button>
                )}
            </div>
        </Modal>
    );
}

export default observer(McpAuthorize);
